import { useEffect, useState } from 'react';
import { getAllSkus, type CatalogItem } from '@gorampe/catalog-adapter';
import { loadCatalog } from '@/lib/catalog';

interface ImageManifest {
  version: string;
  generatedAt?: string;
  totalSkus?: number;
  thumbnails: Record<string, string>;
}

interface UseCatalogResult {
  items: CatalogItem[];
  loading: boolean;
  error: string | null;
}

export function useCatalog(): UseCatalogResult {
  const [items, setItems] = useState<CatalogItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      loadCatalog(),
      fetch('/assets/parts/manifest.json')
        .then((r) => (r.ok ? (r.json() as Promise<ImageManifest>) : null))
        .catch(() => null),
    ])
      .then(([catalog, manifest]) => {
        if (!mounted) return;
        const imageManifest = manifest?.thumbnails ?? {};
        const merged = getAllSkus(catalog, { imageManifest });
        setItems(merged);
        setLoading(false);
      })
      .catch((err: unknown) => {
        if (!mounted) return;
        setError(err instanceof Error ? err.message : 'Unknown error');
        setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { items, loading, error };
}
